import { render, staticRenderFns } from "./ShareView.vue?vue&type=template&id=645d7f0a&scoped=true&"
import script from "./ShareView.vue?vue&type=script&lang=ts&"
export * from "./ShareView.vue?vue&type=script&lang=ts&"
import style0 from "./ShareView.vue?vue&type=style&index=0&id=645d7f0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645d7f0a",
  null
  
)

export default component.exports